/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Tab_AppearanceInputs */

const en_settings_tab_appearance = /** @type {(inputs: Settings_Tab_AppearanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Appearance`)
};

const de_settings_tab_appearance = /** @type {(inputs: Settings_Tab_AppearanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erscheinungsbild`)
};

/**
* | output |
* | --- |
* | "Appearance" |
*
* @param {Settings_Tab_AppearanceInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const settings_tab_appearance = /** @type {((inputs?: Settings_Tab_AppearanceInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Tab_AppearanceInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_tab_appearance(inputs)
	return de_settings_tab_appearance(inputs)
});